/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

//Core imports
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Row, Col, Typography, Spin } from 'antd';

// Misc imports
import { WEBCHAT_WIDGET_MODES } from '../../constants/main';
import { API_WEBCHAT_URL } from '../../constants/env';
import generateWebchatScript from '../../utils/misc/generateWebchatScript';

const AiAssistant = ({ deploymentId }) => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.auth);
  const [isScriptLoading, setIsScriptLoading] = useState(true);
  const botDivId = 'botDiv';

  const loadWebchatScript = () => {
    if(!deploymentId) {
      return;
    }
    if (!document.getElementById('chat-script')) {
      const scriptToAdd = generateWebchatScript({
        deploymentId: deploymentId,
        userName: currentUser?.fullName,
        userEmail: currentUser?.email,
        userId: currentUser?.id,
        mode: WEBCHAT_WIDGET_MODES.EMBEDDED
      });

      const script = document.createElement('script');
      script.id = 'chat-script';
      const scriptFunc = document.createTextNode(scriptToAdd);
      script.appendChild(scriptFunc);
      const parent = document.getElementById(botDivId).parentElement;
      parent.appendChild(script);
    }
  };

  const botDivRef = useCallback(node => {
    if (node !== null) {
      const script = document.createElement('script');
      script.src = API_WEBCHAT_URL;
      script.async = true;
      document.body.appendChild(script);
      script.onload = () =>{
        loadWebchatScript();
        setIsScriptLoading(false);
      };
    }
  }, []);

  return (
    <Row gutter={[16, 16]} wrap={false} className="livechat-ai-assistant flex-column h-100">
      <Col flex="none">
        <Typography.Text className="text-muted fs-sm">
          {t('The Agent is connected to Organization Knowledge Bases. It will help you quickly locate the information you are looking for.')}
        </Typography.Text>
      </Col>

      {
        isScriptLoading ? (
          <Col flex="none" className="w-100 text-center">
            <Spin size="small" />
          </Col>
        ) : null
      }

      <Col span={24} flex="auto" className="pb-4">
        <div id={botDivId} ref={botDivRef} />
      </Col>
    </Row>
  );
};

AiAssistant.propTypes = {
  deploymentId: PropTypes.string
};

export default AiAssistant;
